import { Badge, BadgeProps } from 'zens-storybook'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { ProfileStatus } from 'zens-store'

interface Props extends Omit<BadgeProps, 'status'> {
  status?: ProfileStatus
}
const UserStatusBadge = (props: Props) => {
  const { status, ...otherProps } = props
  const { t } = useTranslation()

  switch (status) {
    case ProfileStatus.Active:
      return <Badge title={t('Active')} light {...otherProps} />
    case ProfileStatus.Invited:
      return <Badge title={t('Invited')} {...otherProps} />
    default:
      return <Badge title={t('Unknown')} status="error" {...otherProps} />
  }
}

export default UserStatusBadge
